export const iconFontAwesomeCodingGears = (
	<i className="fa-solid fa-gears"></i>
);
